import { User } from '@auth0/auth0-angular';

/**
 * Single source of truth for how an authenticated Auth0 user is presented in
 * the UI (avatar initials + display name). Both ProfileMenuComponent and
 * CustomerAccountComponent use these so the name-resolution rules cannot drift.
 */

export function userDisplayName(user: User | null | undefined): string {
  return user?.name || user?.nickname || user?.email || 'Account';
}

export function userInitials(user: User | null | undefined): string {
  const source = (user?.name || user?.nickname || '').trim();

  if (source) {
    const parts = source.split(/\s+/).filter(Boolean);
    const letters = parts.length > 1 ? `${parts[0][0]}${parts[parts.length - 1][0]}` : parts[0].slice(0, 2);
    return letters.toUpperCase();
  }

  return (user?.email?.[0] ?? '?').toUpperCase();
}
